import React, { useState } from "react";
import { Button } from "reactstrap";

import CheckIns         from "./Items/CheckIns";
import BringReferral    from "./Items/BringReferral";
import TelegramJoin     from "./Items/TelegramJoin";
import TelegramPromo    from "./Items/TelegramPromo";
import DragonHitPlay    from "./Items/DragonHitPlay";
import DragonHitTop     from "./Items/DragonHitTop";
import HasOffer         from "./Items/HasOffer";
import HasSurvey        from "./Items/HasSurvey";
import HasCheckInsInRow from "./Items/HasCheckInsInRow";

import User from "~/services/user";


const List = ({checklist, setReload})=> {

  const [isClaimed, setIsClaimed] = useState(false);

  const isCompleted = Object.values(checklist).every(check => check == true);

  const claimReward = ()=> User.completeChecklist().then(()=> setIsClaimed(true));

  return (
    <div className="checklist-activity">
      {isCompleted && !isClaimed && <div className="text-center m-r-20 m-l-20 m-b-20">
        <div className="p-2 b-r-10" style={{background: '#3085dc',color: "white"}}>
          <h6 className="m-t-10"> Congratulations! You completed all the steps. </h6>
        </div>
        <Button color='primary' className="action" onClick={claimReward}> Claim </Button>
      </div>
      }

      {isCompleted && isClaimed && <div className="text-center m-b-20">
        <div className="p-2 b-r-10 text-center" style={{background: '#3085dc',color: "white"}}>
          <h6 className="m-t-10 m-b-10 "> You just earned 2000 points! </h6>
        </div>
      </div>
      }

      <CheckIns          status={checklist.hasCheckIns    }     />
      <TelegramJoin      status={checklist.joinedTelegram} setReload={setReload} />
      <DragonHitPlay     status={checklist.playedDragonHit}     />
      <BringReferral     status={checklist.hasReferrals}        />
      <TelegramPromo     status={checklist.telegramPromo}       />
      <DragonHitTop      status={checklist.dragonHitTop5}       />
      <HasOffer          status={checklist.hasOffer}            />
      <HasSurvey         status={checklist.hasSurvey}           />
      <HasCheckInsInRow  status={checklist.hasCheckInsInRow}    />
    </div>
  );
}

export default List;
